export const formatStringToShort = (string: string, startLength = 6, endLength = 3): string => {
  if (string.length <= startLength + endLength) {
    return string;
  }

  return `${string.slice(0, startLength)}...${string.slice(-endLength)}`;
};
